import React from 'react';
import './Footer.css';

import Logo from '../footerLogo/Logo';
import Info from "../Info/Info";


class Footer extends React.Component {
    // constructor(props) {
    //     super(props);
    // }
    render() {
        return (
            <div className="footer">
                <div className="container">
                    <div className="row justify-content-between align-items-center footer-section">
                        <Logo></Logo>
                        <Info
                            dev='TSIKO'
                            devlink='http://tsiko.pp.ua/'
                            apiNews="NewsApi"
                            apiNewsLink='https://newsapi.org/'
                            apiRate = 'PrivatBank'
                            apiRateLink = 'https://api.privatbank.ua/'
                        >
                        </Info>
                        <div className="col-xl-3 footer-buttons col-lg-3 col-md-3 col-3">
                            <a href={'http://tsiko.pp.ua/'} className="footer-button" style={{marginBottom: 19, backgroundColor: '#66B032'}}>Розробник
                            </a>
                            <a href={'http://tsiko.pp.ua/'} className="footer-button" style={{background: '#FF4F00'}}>Інші проєкти</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;